export * from './getGroup';
export * from './groupingFunc';
export * from './groupSettings';
//# sourceMappingURL=publicExports.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-table/src/core/grouping/publicExports.js
// module id = 2130
// module chunks = 2